import cookie from './common/cookie-utils'
export default {
  state: {
    ops:undefined,
    get token() {
      let token = cookie.get('token');
      return token === 'undefined' || token === undefined ? null : token;
    },
    set token(val) {
      cookie.set('token', val, 365)
    },
    get payType() {
      let payType = cookie.get('payType');
      return payType === 'undefined' || payType === undefined ? null : payType;
    },
    set payType(val) {
      cookie.set('payType', val, 30)
    },
    get payType() {
      let payType = cookie.get('payType');
      return payType === 'undefined' || payType === undefined ? null : payType;
    },
    set payType(val) {
      cookie.set('payType', val, 30)
    },
    // ---角标 start
    get cartGoodsNum() {
      let cartGoodsNum = sessionStorage.getItem('cartGoodsNum');
      return cartGoodsNum === 'undefined' || cartGoodsNum === undefined ? null : Number.parseInt(cartGoodsNum)
    },
    set cartGoodsNum(val){
      sessionStorage.setItem('cartGoodsNum', val)
    },
    get ordersNum() {
      let ordersNum = sessionStorage.getItem('ordersNum');
      return ordersNum === 'undefined' || ordersNum === undefined ? null : JSON.parse(ordersNum)
    },
    set ordersNum(val){
      sessionStorage.setItem('ordersNum', JSON.stringify(val))
    },
    // ---角标 end
    get tabBarActive() {
      let tabBarActive = sessionStorage.getItem('tabBarActive');
      return tabBarActive === 'undefined' || tabBarActive === undefined ? null : Number.parseInt(tabBarActive)
    },
    set tabBarActive(val){
      sessionStorage.setItem('tabBarActive', val)
    },
    get buyList() {
      let buyList = sessionStorage.getItem('buyList');
      return buyList === 'undefined' || buyList === undefined ? null : JSON.parse(buyList);
    },
    set buyList(val){
      sessionStorage.setItem('buyList', JSON.stringify(val))
    },
    get orderCodes() {
      let orderCodes = sessionStorage.getItem('orderCodes');
      return orderCodes === 'undefined' || orderCodes === undefined ? null : JSON.parse(orderCodes);
    },
    set orderCodes(val){
      sessionStorage.setItem('orderCodes', JSON.stringify(val))
    },
    get cartSubmitFlag() {
      let cartSubmitFlag = sessionStorage.getItem('cartSubmitFlag');
      return cartSubmitFlag === 'undefined' || cartSubmitFlag === undefined ? null : JSON.parse(cartSubmitFlag);
    },
    set cartSubmitFlag(val){
      sessionStorage.setItem('cartSubmitFlag', JSON.stringify(val))
    },
    get showBar() {
      let showBar = sessionStorage.getItem('showBar');
      return showBar === 'undefined' || showBar === undefined ? null : JSON.parse(showBar);
    },
    set showBar(val){
      sessionStorage.setItem('showBar', JSON.stringify(val))
    },
    get enableWithholding() {
      let enableWithholding = sessionStorage.getItem('enableWithholding');
      return enableWithholding === 'undefined' || enableWithholding === undefined ? null : JSON.parse(enableWithholding);
    },
    set enableWithholding(val){
      sessionStorage.setItem('enableWithholding', JSON.stringify(val))
    },
    get username() {
      let username = sessionStorage.getItem('username');
      return username === 'undefined' || username === undefined ? null : JSON.parse(username);
    },
    set username(val){
      sessionStorage.setItem('username', JSON.stringify(val))
    },
    get tempAddress() {
      let data = sessionStorage.getItem('tempAddress');
      return data === 'undefined' || data === undefined ? null : JSON.parse(data);
    },
    set tempAddress(val){
      sessionStorage.setItem('tempAddress', JSON.stringify(val))
    },
    get enableAddress() {
      let data = sessionStorage.getItem('enableAddress');
      return data === 'undefined' || data === undefined ? null : JSON.parse(data);
    },
    set enableAddress(val){
      sessionStorage.setItem('enableAddress', JSON.stringify(val))
    }

  }
}
